import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  'checkout.session.invalid.alert.title': {
    id: 'checkout.session.invalid.alert.title',
    defaultMessage: 'You have been logged out',
    description: 'Title for session invalid alert',
  },
  'checkout.session.invalid.alert.button': {
    id: 'checkout.session.invalid.alert.button',
    defaultMessage: 'Log in to continue',
    description: 'Button text for session invalid alert',
  },
  'checkout.session.invalid.alert.message': {
    id: 'checkout.session.invalid.alert.message',
    defaultMessage:
      'It looks like your session has expired. To continue with your purchase, please log in again.',
    description: 'Message for session invalid alert',
  },
});
